import { render, staticRenderFns } from "./importCommercialCompany.vue?vue&type=template&id=0f276f5e&scoped=true"
import script from "./importCommercialCompany.vue?vue&type=script&lang=js"
export * from "./importCommercialCompany.vue?vue&type=script&lang=js"
import style0 from "./importCommercialCompany.vue?vue&type=style&index=0&id=0f276f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f276f5e",
  null
  
)

export default component.exports